export default function Logo({ size = 34, withWordmark = true }) {
  return (
    <span className="flex items-center gap-2.5 select-none" data-testid="brand-logo">
      <img
        src="/logo-ojanzu.png"
        alt="Logo OJANZU — École Française de Janzu"
        style={{ height: size * 1.2, width: "auto" }}
        className="object-contain"
      />
      {withWordmark && (
        <span className="font-serif text-xl tracking-[0.28em] text-foam font-medium">
          JANZU<span className="text-aqua text-xs align-super">®</span>
        </span>
      )}
    </span>
  );
}
